export default __webpack_public_path__ + "static/media/DarkAprobarUsuario.cbf50135.svg";